import React from 'react';
import {View} from 'react-native';

import Gutter from '/component/layout/Gutter';
import testProperties from '/util/testing/testProperties';

import {styles} from './CloseToRankReportContent.style';
import targetConfig from './targetConfig';

// Define the expected structure of each target config item
interface TargetConfigItem {
  dataComponent: React.FC<any>;
  isComplete: (data: any) => boolean;
  title: string;
  titleProps?: Record<string, any>;
  sortOrder: number;
  presentedFor: string[];
  testID: string;
}

// Ensure targetConfig is correctly typed
const typedTargetConfig: Record<string, TargetConfigItem> =
  targetConfig as Record<string, TargetConfigItem>;

interface CloseToRankReportContentProps {
  progressionData: Record<string, any>;
  report: string;
}

const CloseToRankReportContent: React.FC<CloseToRankReportContentProps> = ({
  progressionData = {},
  report = '',
}) => {
  const renderTarget = (name: string) => {
    const config = typedTargetConfig[name];

    if (!config) return null; // Safety check

    const {
      dataComponent: DataComponent,
      isComplete,
      title,
      titleProps,
      testID,
    } = config;
    const data = progressionData[name];

    return (
      <View {...testProperties(testID)} style={styles.listItem} key={name}>
        <DataComponent
          data={data}
          isComplete={isComplete?.(data)}
          title={title}
          titleProps={titleProps}
        />
      </View>
    );
  };

  const renderTargets = () => {
    const targetNames = Object.keys(progressionData);

    // Filter out undefined configs safely
    const existingTargetNames = targetNames.filter(
      name => typedTargetConfig[name] !== undefined,
    );

    const configuredTargetNames = existingTargetNames.filter(name =>
      typedTargetConfig[name]?.presentedFor.includes(report),
    );

    // Ensure sorting function safely accesses properties
    const sortedTargetNames = configuredTargetNames.sort(
      (aName, bName) =>
        (typedTargetConfig[aName]?.sortOrder ?? 0) -
        (typedTargetConfig[bName]?.sortOrder ?? 0),
    );

    return sortedTargetNames.map(name => renderTarget(name));
  };

  return (
    <View>
      <Gutter>
        {Object.keys(progressionData).length > 0 && renderTargets()}
      </Gutter>
    </View>
  );
};

export default CloseToRankReportContent;
